import React from 'react';

import InputText from '@/design_system/InputText';
import Stack from '@/design_system/Stack';
import { I18nWording, useDatabaseTranslation } from '@/services/i18n';

interface Field {
  id: string;
  label: I18nWording;
  type: 'text' | 'textarea' | 'checkbox' | 'radio' | 'select';
}

const CustomFieldsGroup = ({
  customFields,
  setCustomFields,
  size,
  fields,
  disabled = false,
}: {
  customFields: Record<string, string>;
  setCustomFields: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  size?: 'medium' | 'large';
  disabled?: boolean;
  fields: Field[] | undefined;
}) => {
  const { _db } = useDatabaseTranslation();

  return (
    <Stack gap="0.5rem">
      {fields &&
        fields.map(({ id, label, type }) => {
          const value = customFields[id] ?? '';

          switch (type) {
            case 'text':
              return (
                <InputText
                  key={id}
                  label={_db(label)}
                  placeholder={_db(label)}
                  value={value}
                  onChange={(value) =>
                    setCustomFields((prev) => ({
                      ...prev,
                      [id]: value,
                    }))
                  }
                  size={size}
                  isDisabled={disabled}
                />
              );
            default:
              return null;
          }
        })}
    </Stack>
  );
};

export default CustomFieldsGroup;
